<script setup>
import { computed } from 'vue';
import { useAccount } from 'dashboard/composables/useAccount';
import { useI18n } from 'vue-i18n';
import Logo from 'next/icon/Logo.vue';

const { accountScopedRoute } = useAccount();
const { t } = useI18n();

const menuItems = computed(() => [
  { label: t('SIDEBAR.INBOX'), icon: 'i-lucide-inbox', to: accountScopedRoute('inbox_view') },
  { label: t('SIDEBAR.CONVERSATIONS'), icon: 'i-lucide-message-circle', to: accountScopedRoute('home') },
  { label: t('SIDEBAR.CONTACTS'), icon: 'i-lucide-contact', to: accountScopedRoute('contacts_dashboard_index') },
  { label: t('SIDEBAR.REPORTS'), icon: 'i-lucide-chart-spline', to: accountScopedRoute('account_overview_reports') },
]);
</script>

<template>
  <header class="h-20 header w-full flex-shrink-0 border-b border-n-slate-3 flex items-center px-8 z-50 shadow-subtle">
    <div class="flex items-center gap-6 mr-10">
      <div class="flex items-center justify-center size-10 rounded-xl bg-n-slate-2 shadow-soft border border-n-slate-3">
        <Logo class="size-6 text-n-brand" />
      </div>
      <div class="h-6 w-px bg-n-slate-3" />
    </div>

    <nav class="flex items-center gap-4 flex-grow">
      <RouterLink
        v-for="item in menuItems"
        :key="item.label"
        :to="item.to"
        class="flex items-center gap-2 px-4 py-2 rounded-xl transition-all duration-300 group"
        active-class="bg-n-slate-2 shadow-subtle text-n-brand"
        inactive-class="hover:bg-n-slate-2 text-n-slate-11 hover:text-n-brand"
      >
        <span :class="[item.icon, 'size-5 transition-transform duration-300 group-hover:scale-110']" />
        <span class="text-xs font-semibold uppercase tracking-wide">{{ item.label }}</span>
      </RouterLink>
    </nav>
  </header>
</template>

<style scoped>
.no-scrollbar::-webkit-scrollbar { display: none; }
.no-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }
</style>
